import { 
    BicycleCardsSection,
    FormSection,
    HeroSection,
    ShopingItemsSection,
    SliderSection,
    TitleSection 
} from "./sections"



export const MainPage=()=>{
    
    
    return(
        <>
            <HeroSection/>
            <TitleSection/>
            <BicycleCardsSection/>
            <SliderSection/>
            <ShopingItemsSection/>
            <FormSection/>
        </>
    )
}